import * as types from "../types/contractDeactivationStatus"
import { getContractDeactivationStatus } from "services"

export const fetchContractDeactivationStatus = () => (
  async (dispatch) => {
    const response = await getContractDeactivationStatus()

    dispatch({
      type: types.FETCH_CONTRACT_DEACTIVATION_STATUS,
      status: response
    })
  }
)

export const updateContractDeactivationStatus = status => ({
  type: types.UPDATE_CONTRACT_DEACTIVATION_STATUS,
  status
})

export const deleteContractDeactivationStatus = () => ({
  type: types.DELETE_CONTRACT_DEACTIVATION_STATUS
})